import GuaranteedRentPage from "@/pages/guaranteed-rent/GuaranteedRentPage";
import { getCity } from "@/pages/guaranteed-rent/cityConfig";

export default function GuaranteedRentBrighton() {
  return <GuaranteedRentPage city={getCity("brighton")} />;
}